import industries from './industryList.js';
import employee from './employeeList.js';
import countries from './countryList.js'

export default { industries, employee, countries };
